import { faqService } from '../services'
import { createModule } from './module-factory'

export const faqs = createModule(faqService)
